import { defineAsyncComponent } from 'vue'
export default {
  "app-breadcrumbs": defineAsyncComponent(() => import("/vercel/path1/layouts/AppBreadcrumbs.vue").then(m => m.default || m)),
  "app-footer": defineAsyncComponent(() => import("/vercel/path1/layouts/AppFooter.vue").then(m => m.default || m)),
  "app-header": defineAsyncComponent(() => import("/vercel/path1/layouts/AppHeader.vue").then(m => m.default || m)),
  "app-menu": defineAsyncComponent(() => import("/vercel/path1/layouts/AppMenu.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path1/layouts/default.vue").then(m => m.default || m))
}